
export default function ThankYouCommTCM() {
    return (
        <div class="flex items-center justify-center p-8">
            <div class="bg-white rounded-2xl border border-gray-100 px-10 py-10 max-w-md w-full text-center">

                <div class="w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-5">
                <svg class="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M5 13l4 4L19 7" />
                </svg>
                </div>

                <h2 class="text-2xl font-medium text-gray-900 mb-3">Thank you</h2>

                <p class="text-sm text-gray-500 leading-relaxed">
                An expert from our team will be in touch with your quote shortly.
                </p>

            </div>
        </div>
    )
}